import { IAppContext } from 'App/AppContext';
import { TFunction } from 'i18next';
import { CopilotConversationItem, CopilotConversionItemType } from 'models/copilot/copilotConversation';

export enum ProcessExceptionType {
  GraphClientError = 'GRAPH001',
  GraphCreateFolderFailed = 'GRAPH002',
  GraphUploadFailed = 'GRAPH003',
  GraphCouldNotFindItem = 'GRAPH004',
  CouldNotFindInFileStorage = 'STORAGE001',
  InvalidState = 'INVALID_STATE',
  TenantScopedProcessRunning = 'SCOPE_CONFLICT',
  CreatePermissions = 'PERMISSIONS001',
  SharepointIntegrations = 'PERMISSIONS002',
  // a failed model call in a process step; the message is the step's own sentence
  ProcessStepFailed = 'PROCESS_STEP_FAILED',
}

export const ProcessExceptionCodes = ProcessExceptionType;

export default class ProcessException {
  code: string;

  message?: string | undefined;

  constructor() {
    this.code = '';
  }

  static getMessage(
    code: ProcessExceptionType,
    t: TFunction<string[]>,
    appContext: IAppContext,
    data?: string,
  ): CopilotConversationItem {
    const messageItem = new CopilotConversationItem();
    messageItem.type = CopilotConversionItemType.Copilot;

    switch (code) {
      case ProcessExceptionType.GraphClientError:
        messageItem.response = t('copilot:ProcessException.GraphClientError');
        break;
      case ProcessExceptionType.GraphCreateFolderFailed:
        messageItem.response = t('copilot:ProcessException.GraphCreateFolderFailed');
        break;
      case ProcessExceptionType.GraphUploadFailed:
        messageItem.response = t('copilot:ProcessException.GraphUploadFailed');
        break;
      case ProcessExceptionType.GraphCouldNotFindItem:
        messageItem.response = t('copilot:ProcessException.GraphCouldNotFindItem');
        break;
      case ProcessExceptionType.CouldNotFindInFileStorage:
        messageItem.response = t('copilot:ProcessException.CouldNotFindInFileStorage');
        break;
      case ProcessExceptionType.InvalidState:
        messageItem.response = t('copilot:ProcessException.InvalidState');
        break;
      case ProcessExceptionType.TenantScopedProcessRunning:
        const user = appContext.globalDataCache.users.get(data ?? '');

        messageItem.response = t('copilot:ProcessException.TenantScopedProcessRunning', {
          user: user?.name ?? 'Unknown User',
        });
        break;
      case ProcessExceptionType.CreatePermissions:
        messageItem.response = t('copilot:ProcessException.CreatePermissions');
        break;
      case ProcessExceptionType.SharepointIntegrations:
        messageItem.type = CopilotConversionItemType.SharepointIntegrations;
        break;
      case ProcessExceptionType.ProcessStepFailed:
        messageItem.response = data?.trim() || t('copilot:ProcessException.InvalidState');
        break;
      default:
        messageItem.response = t('copilot:NoAnswer');
        break;
    }

    return messageItem;
  }
}
